// HEAD DATA
export const headData = {
  title: 'FTNL | Digital Solutions, Products, and Delivery',
  lang: 'en',
  description:
    'FTNL is a France-based company that designs, delivers, and advises on digital products, architecture, and program execution.',
};

export const siteData = {
  navigation: [
    { label: 'Services', href: '#services' },
    { label: 'Approach', href: '#approach' },
    { label: 'Product', href: '#product' },
    { label: 'Contact', href: '#contact' },
  ],
  hero: {
    eyebrow: 'France-based digital partner',
    title: 'We design, build and manage digital solutions and products.',
    body:
      'FTNL helps companies turn ideas into clear, useful digital experiences. We combine solution design, product development, consulting, and structured delivery to move projects from concept to launch.',
    primaryCta: {
      label: 'Start a project',
      href: 'mailto:contact@ftnl.org',
    },
    secondaryCta: {
      label: 'See our approach',
      href: '#approach',
    },
    metrics: [
      { value: 'France', label: 'Based and operating from' },
      { value: 'End-to-end', label: 'Design, consulting, and delivery' },
      { value: 'Live delivery', label: 'Products launched and managed' },
    ],
    spotlight: {
      label: 'Example project',
      title: 'A shipped CRM product',
      description:
        'A mobile-first CRM built for creators, freelancers, and small businesses who need a simple way to manage relationships and pipeline activity.',
    },
  },
  servicesIntro: {
    title: 'Product delivery and consulting, in one partner',
    body:
      'FTNL not only designs and ships digital products. We also provide consulting services across infrastructure architecture, cloud and security, application architecture, and project and program management.',
  },
  services: [
    {
      title: 'Product Design',
      description:
        'We define the right product shape, user flows, and technical direction before teams overbuild the wrong thing.',
    },
    {
      title: 'Product Development',
      description:
        'We build modern digital products with a focus on clarity, maintainability, and practical business value.',
    },
    {
      title: 'Infrastructure Architecture',
      description:
        'We advise on cloud foundations, security posture, environments, and scalable infrastructure choices across modern platforms.',
    },
    {
      title: 'Application Architecture',
      description:
        'We shape application structures, integrations, and maintainable technical foundations that support long-term delivery.',
    },
    {
      title: 'Project Management',
      description:
        'We keep execution structured, visible, and accountable so projects stay aligned from kickoff to release.',
    },
    {
      title: 'Program Management',
      description:
        'We support larger delivery portfolios with governance, coordination, and decision-making frameworks that keep multiple workstreams moving together.',
    },
  ],
  credentials: {
    title: 'Consulting backed by current certifications',
    body:
      'Our consultants combine hands-on delivery with current certifications across major cloud providers and project leadership frameworks.',
    items: [
      'Certified across AWS, Google Cloud, and Azure',
      'Advisory coverage for cloud, security, and infrastructure architecture',
      'PRINCE2 and PMP certified project and program management leadership',
    ],
  },
  approach: {
    title: 'How we work',
    steps: [
      {
        step: '01',
        title: 'Clarify the opportunity',
        description:
          'We map the problem, goals, users, constraints, and architecture context so the project starts with strong decisions instead of assumptions.',
      },
      {
        step: '02',
        title: 'Design the solution',
        description:
          'We shape the product, application, infrastructure, and delivery plan together, balancing ambition with what can actually be shipped well.',
      },
      {
        step: '03',
        title: 'Lead delivery',
        description:
          'We execute with modern tools, structured governance, and clear milestones, then support ongoing management as products and programs evolve.',
      },
    ],
  },
  product: {
    label: 'Example project',
    title: 'A live product built for daily use',
    description:
      'Track CRM is one example of how FTNL approaches product work: focused scope, strong usability, and a product shaped around real operators instead of unnecessary complexity.',
    bullets: [
      'Mobile-first CRM experience',
      'Built for creators, freelancers, and small businesses',
      'Simple interface designed for daily use',
    ],
    cta: {
      label: 'View project',
      href: 'https://www.track-app.io/',
    },
  },
  contact: {
    title: 'Need help shaping a product, architecture, or delivery program?',
    body:
      'FTNL works with teams that want hands-on execution, stronger technical foundations, and consulting support that can move from architecture into delivery.',
    cta: {
      label: 'contact@ftnl.org',
      href: 'mailto:contact@ftnl.org',
    },
  },
  footer: {
    text: 'FTNL designs, delivers, and advises on digital products, architecture, and program execution.',
    linkedin: 'https://www.linkedin.com/company/ftnl/',
  },
};
